import React from 'react';
import { Grid } from '@mui/material';

type RoomChipProps = {
  label: string;
  dot: string;
  soft: string;
  textColor?: string;
};

/** A room or workshop name on a tinted chip, led by a small square in the room's identity colour. */
export const RoomChip = ({ label, dot, soft, textColor }: RoomChipProps) => (
  <Grid
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.75,
      paddingInline: 1.25,
      paddingBlock: 0.5,
      borderRadius: '4px',
      bgcolor: soft,
      color: textColor ?? 'text.primary',
      fontSize: 14,
      fontWeight: 500,
      whiteSpace: 'nowrap',
    }}>
    <Grid component="span" aria-hidden sx={{ width: 8, height: 8, borderRadius: '2px', bgcolor: dot, flexShrink: 0 }} />
    {label}
  </Grid>
);
